module.exports = __webpack_public_path__ + "static/media/Nigeria-LNG.fd624ce4.png";